import { React, useState, useEffect } from "react";
import { InformationsWrapper, FormGroup } from "../customersPage.styled";
import FormAccordion from "../../../components/Form/FormAccordion";
import { getCustomerInfo } from "../customersUtils";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import { Backdrop, CircularProgress } from "@mui/material";

function FinancialInfo() {
	const { id } = useParams();
	const [data, setData] = useState();
	const [loading, setLoading] = useState(true);
	//use redux
	useEffect(() => {
		getCustomerInfo(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else {
					setLoading(false);
					if (res.result) {
						// console.log(res.result)
						setData(res.result);
					} else {
						toast.error("Unable to fetch financial information");
					}
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(error);
			});
	}, []);

	/* eslint-disable react/prop-types */
	const FinanceComponent = ({ title, status }) => {
		return (
			<FormAccordion title={title} open={status}>
				<div className='grid grid-cols-3 gap-3'>
					<FormGroup>
						<label>Bank Verification Number</label>
						<p>{data?.profile ? data.profile["BVN"] : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Wallet balance</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Last funded</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Card number</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>CVV</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Card holders name</label>
						<p>
							{data?.profile && data?.profile?.bankAccounts?.length > 0
								? data.profile.bankAccounts[0].accountName
								: "-- "}
						</p>
					</FormGroup>

					<FormGroup>
						<label>Bank name</label>
						<p>
							{data?.profile && data.profile?.bankAccounts?.length > 0
								? data.profile.bankAccounts[0].bankName
								: "-- "}
						</p>
					</FormGroup>

					<FormGroup>
						<label>Expiry date</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Lease-Income ratio</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Credit score</label>
						<p>{data?.creditScore ? data.creditScore : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Savings</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Referral bonus</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Risk appetite</label>
						<p>--</p>
					</FormGroup>

					<FormGroup>
						<label>Referral code</label>
						<p>{data?.inviteCode ? data.inviteCode : "--"}</p>
					</FormGroup>
				</div>
			</FormAccordion>
		);
	};

	return (
		<InformationsWrapper>
			<p className='avatar'>
				<img src='/images/transactions_img.svg' alt='transaction image' />
			</p>
			<FinanceComponent title='Personal profile' status={true} />
			<FinanceComponent title='Business profile' status={false} />
			<FinanceComponent title='Investor profile' status={false} />

			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</InformationsWrapper>
	);
}

export default FinancialInfo;
